import { differenceInMonths, parse } from 'date-fns';

export const isRecentDocument = (date: string) => {
  if (!date) return false;
  const dateObj = parse(date, 'dd/MM/yyyy', new Date());
  const currentDate = new Date();
  const monthDifference = differenceInMonths(currentDate, dateObj);
  if (monthDifference < 3) {
    return true;
  }
  return false;
};
